module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';
	
	fox.registerWidget('Content_SceneViewer', {
		configure: function(options) {
			this.registerOptions('', {
				useCollectionId: true,
				widgets: {
					sceneDl: {
						widget: 'Datalayer',
						limit: 1
					},

					currentScene: {
						widget: 'Content_Browser',
						container: '#scenes-player',
						dataLayer: '@parent #sceneDl',
						externalLoad: true,
						preset: 'search',
						list: {
							manualRender: true,
							'tpl.row': 'sitepage_scene_playerBlock',
							handleDom: {
								downloadLinks: {
									target: '.toggleDownloads',
									'event': 'click',
									callback: '@parent @parent:downloadLinksToggle'
								},
								modelsMore: {
									target: '.model-toggle',
									'event': 'click',
									callback: '@parent @parent:modelsMore'
								},
								decriptionToggle: {
									target: '.desc-toggle',
									'event': 'click',
									callback: '@parent @parent:decriptionToggle'
								}
							}
						}
					},

					flashPlayer: {
						widget: 'Content_FlashPlayer',
						contentWidget: '@parent #currentScene #list',
						'handleWom.recieveContentId.widget': '@parent',
						jsonizeMapRequest: false,
						onPausePlayerImage: this.getBannerSrc()
					},

					currentRating: {
						widget: 'Social_Rating',
						targetDl: '@parent #sceneDl',
						targetField: 'id',
						'embed.widget': '@parent #currentScene #list'
					},

					sceneComments: {
						//showComments: false,
						widget: 'Social_Comments',
						targetDl: '@parent #sceneDl',
						template: 'social_comment_scene',
						'embed.widget': '@parent #currentScene #list',
						'handleDom.toggleForm': {
							targetWidget: '@parent #currentScene #list'
						}
					},

					relatedContent: {
						widget: 'Content_Related'
					}
				},

				handleWom: {
					'navigator': {
						'event': 'modified_1',
						widget: fox.Navigator,
						callback: '_preRunScene',
						'params.listenHistory': true,
						'params.alwaysActive': true
					},

					scrollToPlayer: {
						'event': 'loaded',
						widget: '#sceneDl',
						callback: 'scrollToPlayer',
						'params.prefix': 'scrollToPlayer'
					}
				}
			});
			
			if (fox.site.member) {
				this.registerOptions('', {
					widgets: {
						favorite: {
							widget: 'Social_Favorite',
							targetDl: '@parent #sceneDl',
							targetField: 'id',
							'embed.widget': '@parent #currentScene #list'
						}
					}
				});
			}
			this.callParent('configure', arguments);
		},

		scrollToPlayer: function() {
			var $player = $(this.rwom1('#flashPlayer').getPlayerContainer());

			function scroll ($player) {
				$('body, html').animate({
					scrollTop: $player.offset().top - 50
				}, 500);
			}

			if($player.length){
				scroll($player);
			} else {
				this.wait('#flashPlayer', 'playerRunning').then(function () {
					scroll($(this.rwom1('#flashPlayer').getPlayerContainer()));
				}.bind(this));
			}
		},

		setTitle: function() {
			var metaDescription = fox.dom.selectFirst('meta[name="description"]');
			var parseTitle = fox.Navigator.get(2) ? decodeURIComponent(fox.Navigator.get(2).replace(/-/g, ' ')) : '';

			//document.title = parseTitle + ' - Sex Movies Featuring ' + fox.getEnv('screenName');

			if(!metaDescription.content.length){
				metaDescription.setAttribute('content', 'Watch ' + fox.getEnv('screenName') + ' Best Porn Videos in HD. Free movies ' + parseTitle + '.');
			}
			this.wom1('#downloadButton').render();
		},

		modelsMore: function() {
			$('#cast-list').toggleClass('show');
		},

		decriptionToggle: function() {
			$('.description').toggleClass('show');
		},

		toggleComments: function() {
			$('.reviews-actions-block').toggle();
		},

		init: function() {
			return this.callParent('init', arguments);
		},

		running: function (argument) {
			this._attacheGlobalWindowEvents();

			this.callParent('running', arguments);
		},

		activate: function() {
			//this.rwom1('#currentScene #list')._readyToEmbed = false;
			this.callParent('activate', arguments);
			this.dispatchEvent('activateSceneViewer');

			this._attacheGlobalWindowEvents();
		},

		deactivate: function () {
			this._detacheGlobalWindowEvents();

			this.callParent('deactivate', arguments);
		},

		_preRunScene: function(id) {

			this.contentId = id;
			//this.setTitle();
			
			if (this.isActive()) {
				this.runScene();
			}

			this.waitEvent(this, 'activateSceneViewer', 'runScene');

		},

		runScene: function () {
			this.sceneDl = this.requireEmbeddedWidget('sceneDl');

			this.sceneDl.addFilter('id', ['id'], [this.contentId]).load();
			
			if (this.getOption('useCollectionId')) {
				this.handleEvent(this.sceneDl, 'loaded', fox.bind(function () {
					this.rwom1('#otherScenes').setCollectionId(this.sceneDl.getObjectRelation('collectionId').getObjectValue('id'));
					this.dispatchEvent('setContentId', this.contentId);
				}, this));
			} else {
				this.dispatchEvent('setContentId', this.contentId);
			}
		},

		getBannerSrc: function () {
			var orientations = {'straight':'1', 'gay':'2','shemale':'3'};
			var orient = fox.getEnv('siteProps.channelSets.current') || fox.getEnv('siteProps.defaultOrientation');
			
			if (orientations[orient]) {
				return fox._isNewFe ?
					require('../../images/player_banner' + orientations[orient] + '.png') :
					(fox.getEnv('design.url') + '/images/player_banner' + orientations[orient] + '.png');
			}

			return fox._isNewFe ? require('../../../site/root/images/player_banner.png') : (fox.getEnv('design.url') + '/images/player_banner.png');
		},

		downloadLinksToggle: function(elt, alias, w, e) {
			if (e.canceBubble) {
				e.canceBubble = true;
			} else if (e.stopPropagation) {
				e.stopPropagation();
			}

			elt = $(elt);
			// var container = this.rwom1('#downloadLinks').getOption('container');

			// w = ($(container).width()/2)-($(elt).width()/2);

			// $(elt).toggleClass('active');
			// $(container).css({'margin-left':'-' + w + 'px' });
			// $(container).toggleClass('active');

			if (elt.hasClass('active')) {
				this._closeDownloadBlock();
			} else {
				this._openDownloadBlock();
			}
		},

		_attacheGlobalWindowEvents: function (argument) {
			$(document).on('click', {widget: this}, this._closeDownloadBlock);
			$(document).on('keyup', {widget: this}, this._closeOnEsc);
		},

		_detacheGlobalWindowEvents: function (argument) {
			$(document).off('click', this._closeDownloadBlock);
			$(document).off('keyup', this._closeOnEsc);
		},

		_openDownloadBlock: function (el, w, alias, e) {
			this.hookWrapper('openDownloadBlock');
		},

		openDownloadBlock: function () {
			var elt = $('.toggleDownloads');
			var container = this.rwom1('#downloadLinks').getOption('container');
			var w = ($(container).width()/2)-($(elt).width()/2);

			$(elt).addClass('active');
			$(container).css({'margin-left':'-' + w + 'px' });
			$(container).addClass('active');
		},

		_closeDownloadBlock: function (e) {

			if (fox.objectGet(e, 'data.widget')) {
				e.data.widget.hookWrapper('closeDownloadBlock');
				
				return;
			}

			this.hookWrapper('closeDownloadBlock');
		},

		closeDownloadBlock: function () {
			var elt = $('.toggleDownloads');
			var container = this.rwom1('#downloadLinks').getOption('container');

			$(elt).removeClass('active');
			$(container).removeClass('active');
		},

		_closeOnEsc: function (e) {
			if (e.keyCode === 27) {
				e.data.widget._closeDownloadBlock(e);
			}
		},

		getContentId: function () {
			return this.contentId;
		}

	}, 'Controller');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/widget/content/sceneViewer.js
// module id = 448
// module chunks = 4